import { TMechanicDashboardActions } from './mechanic-dashboard.actions';
import { TMechanicDashboardState, TMechanicDashboardActionType } from './mechanic-status-dashboard.models';

export const intialState: TMechanicDashboardState = {
  mechanicDashboardInfo: null,
};

export function mechanicDashboardReducer(
  state = intialState,
  action: TMechanicDashboardActions,
): TMechanicDashboardState {
  switch (action.type) {
    case TMechanicDashboardActionType.GetMechanicDashboardInfo:
      return {
        ...state,
        mechanicDashboardInfo: null,
      };
    case TMechanicDashboardActionType.GetMechanicDashboardInfoSuccess:
      return {
        ...state,
        mechanicDashboardInfo: action.mechanicDashboardInfo,
      };
    default:
      return state;
  }
}
